import React, { useContext, useState } from 'react'
import {
  ButtonsDiv,
  CloseDiv,
  CloseImg,
  Container,
  CreateButtonDiv,
  CreateButtonImage,
  CreateButtonText,
  ErrorMessage,
  HeaderDiv,
  HeaderText,
  InputDiv,
  InputField,
  LabelCreate,
  TipText,
} from '../CreateAccessUserModal/style'
import cross from '../../assets/addStockModal/cross.svg'
import plus from '../../assets/headers/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import axios from '../../config/axios'
import { FeedbackContext } from '../../contexts/FeedbackContext'

const CreateTenantModal: React.FC = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    segment: '',
    cnpj: '',
    adminName: '',
    adminEmail: '',
    adminPassword: '',
    adminPhone: '',
  })
  const { setModalActive } = useContext(ModalContext)
  const { setFeedback } = useContext(FeedbackContext)
  const [error, setError] = useState('')
  const [click, setClick] = useState(false)

  const validateForm = () => {
    if (!formData.companyName || formData.companyName.length < 3) return false
    if (!formData.segment || formData.segment.length < 2) return false
    if (!formData.cnpj || formData.cnpj.length < 14) return false
    if (!formData.adminName || formData.adminName.length < 3) return false
    if (!formData.adminEmail || !formData.adminEmail.includes('@')) return false
    if (!formData.adminPassword || formData.adminPassword.length < 6) return false
    if (!formData.adminPhone || formData.adminPhone.length < 10) return false
    return true
  }

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    setError('')
  }

  const createTenant = async () => {
    if (!validateForm()) {
      setClick(true)
      return
    }

    try {
      await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/tenant`, formData)
      setFeedback({
        isOpen: true,
        message: 'Tenant cadastrado com sucesso',
        statusOk: true
      })
      setModalActive(false)
      window.location.reload()
    } catch (error: any) {
      console.error('Erro ao criar tenant:', error)
      if (error.response?.status === 409) {
        setError('Tenant com este CNPJ já existe')
      } else if (error.response?.status === 400) {
        const messages = error.response?.data?.message
        if (Array.isArray(messages)) {
          setError(messages.join(', '))
        } else {
          setError('Dados inválidos. Verifique os campos obrigatórios.')
        }
      } else {
        setError('Erro ao criar tenant')
      }
      setFeedback({
        isOpen: true,
        message: error.response?.data?.message || 'Erro ao cadastrar tenant',
        statusOk: false
      })
    }
  }

  const isValid = validateForm()

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Cadastrar novo tenant</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>

      {error && <ErrorMessage>{error}</ErrorMessage>}

      <InputDiv>
        <LabelCreate>Nome da empresa *</LabelCreate>
        <InputField
          placeholder='Digite o nome da empresa'
          type='text'
          value={formData.companyName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('companyName', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Segmento *</LabelCreate>
        <InputField
          placeholder='Digite o segmento (ex: Aco, fashion)'
          type='text'
          value={formData.segment}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('segment', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>CNPJ *</LabelCreate>
        <InputField
          placeholder='Digite o CNPJ (apenas números)'
          type='text'
          value={formData.cnpj}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('cnpj', e.target.value.replace(/\D/g, ''))}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Nome do responsável *</LabelCreate>
        <InputField
          placeholder='Digite o nome completo do administrador'
          type='text'
          value={formData.adminName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('adminName', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Email do responsável *</LabelCreate>
        <InputField
          placeholder='Digite o email do administrador'
          type='email'
          value={formData.adminEmail}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('adminEmail', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Senha *</LabelCreate>
        <InputField
          placeholder='Digite a senha (mínimo 6 caracteres)'
          type='password'
          value={formData.adminPassword}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('adminPassword', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Telefone para contato *</LabelCreate>
        <InputField
          placeholder='Digite o telefone'
          type='text'
          value={formData.adminPhone}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('adminPhone', e.target.value)}
        />
      </InputDiv>

      <ButtonsDiv>
        {!isValid && click && (
          <TipText>Preencha todos os campos obrigatórios corretamente</TipText>
        )}
        <CreateButtonDiv onClick={createTenant}>
          <CreateButtonImage src={plus} alt='Plus icon' />
          <CreateButtonText>Cadastrar tenant</CreateButtonText>
        </CreateButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default CreateTenantModal
